<template>
	<div class="signals-list">
		<div class="nobr" v-for="signal in signals" :key="signal.signal">
			{{ signal.signal }} <span class="signals-satellites-count">{{ signal.satellites_count }}</span>
		</div>
	</div>
</template>

<script>
export default {
	props: ['signals'],
}
</script>

<style scoped>
.signals-list {
	margin-top: 4px;
	display: flex;
	flex-wrap: wrap;
	gap: 4px;
}

.signals-satellites-count {
	background-color: #dddddd;
	padding: 0 2px;
	border-radius: 4px;
}
</style>

